import { FC, useState } from "react";
import { AutocompleteOption, MiPopper } from "@miplatform/components";
import { TYPOGRAPHY_VARIANTS } from "@miplatform/constants";
import { useRouter } from "@miplatform/hooks";
import { IOrder } from "@miplatform/types";
import { MenuItem, MenuItemProps, Typography, useTheme } from "@mui/material";
import { Box } from "@mui/system";
import { OrderSearchOptionChip } from "./OrderSearchOptionChip";
import { OrderSearchOptionPopperContent } from "./OrderSearchOptionPopperContent";

export const OrderSearchOption: FC<OrderSearchOptionProps> = ({
  option,
  props,
  close,
}) => {
  const { push } = useRouter();
  const theme = useTheme();

  const [timeoutId, setTimeoutId] = useState<number | null>(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const openPopper = (e: React.MouseEvent<HTMLElement>) => {
    const { currentTarget } = e;
    const timeout = setTimeout(() => {
      if (!anchorEl) {
        setAnchorEl(currentTarget);
      }
    }, 250);
    setTimeoutId(timeout);
  };

  const closePopper = () => {
    setAnchorEl(null);
    if (timeoutId) {
      clearTimeout(timeoutId);
      setTimeoutId(null);
    }
  };

  const navigateToOrder = () => {
    close();
    push(`/homes/${option.home.id}/orders?orderId=${option.id}`);
  };

  return (
    <MenuItem
      {...props}
      onClick={navigateToOrder}
      onMouseEnter={openPopper}
      onMouseLeave={closePopper}
    >
      <Box display="flex" flexDirection="row" gap={2} alignItems="center">
        <OrderSearchOptionChip option={option} />
        <Typography variant={TYPOGRAPHY_VARIANTS.BODY1}>
          {option.orderTemplateName} - {option.home.address.addressLine1}
        </Typography>
        <MiPopper
          anchorEl={anchorEl}
          arrowColor={option.orderTemplateColor || theme.palette.primary.main}
          showArrow
          open={Boolean(anchorEl)}
          placement="right"
          sx={{
            borderRadius: theme.spacing(2),
          }}
        >
          <OrderSearchOptionPopperContent order={option} />
        </MiPopper>
      </Box>
    </MenuItem>
  );
};

interface OrderSearchOptionProps {
  option: AutocompleteOption & IOrder;
  props: MenuItemProps;
  close: () => void;
}
